(function () {
  'use strict';

  // Tracks "Added Quiz Product to Cart" to Klaviyo for the Bundle Builder
  // embedded inside the product quiz's thank-you page, without touching
  // bundle-builder-page.js/.css. Only activates when that embed is present
  // (.product-quiz__bundle-builder-wrap), so loading this file has zero
  // effect on the standalone /pages/bundle-builder page, which doesn't
  // have that wrapper.
  //
  // bundle-builder-page.js doesn't dispatch any custom event for its own
  // "Add to Cart" action, so there's nothing to listen for — instead this
  // wraps window.fetch to observe the same /cart/add.js call it already
  // makes. The request/response pass through completely unmodified; this
  // only reads a cloned copy of the response after the fact, so the real
  // add-to-cart flow (cart drawer, redirect, error handling) is untouched.
  // Bundle items carry a `_bundle_id` line property (set by
  // bundle-builder-page.js) used here to identify them and avoid
  // double-counting the quiz's own single-item add-to-cart, which is
  // already tracked separately in product-quiz-klaviyo.js.

  var wrap = document.querySelector('.product-quiz__bundle-builder-wrap');
  if (!wrap) return;

  var originalFetch = window.fetch;
  if (!originalFetch) return;

  function getEmail() {
    var root = document.querySelector('[data-product-quiz]');
    if (!root) return '';
    try {
      var raw = window.localStorage.getItem('tru_quiz_state_' + root.getAttribute('data-section-id'));
      var state = raw ? JSON.parse(raw) : null;
      return (state && state.email) || '';
    } catch (e) {
      return '';
    }
  }

  function isBundleAddRequest(url, options) {
    if (!options || options.method !== 'POST') return false;
    if (String(url).indexOf('/cart/add.js') === -1) return false;
    try {
      var body = JSON.parse(options.body);
      var items = body.items || [];
      return !!(items.length && items[0].properties && items[0].properties._bundle_id);
    } catch (e) {
      return false;
    }
  }

  function trackAddedItems(response) {
    if (!response.ok) return;
    if (typeof window.klaviyo === 'undefined' || typeof window.klaviyo.track !== 'function') return;

    response.clone().json().then(function (data) {
      var items = (data.items || []).map(function (item) {
        return {
          ProductName: item.product_title || item.title || '',
          ProductVariant: item.variant_title || '',
          Quantity: item.quantity,
          Price: (item.price / 100).toFixed(2)
        };
      });
      if (!items.length) return;

      var properties = { items: items, source: 'bundle_builder' };
      var email = getEmail();
      if (email) properties.$email = email;

      window.klaviyo.track('Added Quiz Product to Cart', properties).catch(function () {});
    }).catch(function () {});
  }

  window.fetch = function (url, options) {
    var promise = originalFetch.apply(window, arguments);

    if (isBundleAddRequest(url, options)) {
      promise.then(trackAddedItems).catch(function () {});
    }

    return promise;
  };
})();
